export * from './alunos.component';
export * from './alunos.module';
